import tinycolor from "tinycolor2"
import theme from "./theme"

const isColorLight = (color: string) => tinycolor(color).isLight() && !(color === theme.colors.brand.default)

export default isColorLight
